<div
  class="border border-periwinkle-border rounded-[10px] bg-periwinkle-soft text-center px-5"
  [class.py-8]="compact"
  [class.py-12]="!compact"
>
  @if (showSeal) {
    <app-logo
      class="mx-auto mb-3 block h-7 w-7 overflow-hidden rounded-[8px] border border-brand-lavender-border bg-brand-ink p-1 text-brand-lavender"
      [clickable]="false"
    ></app-logo>
  }
  <div
    class="mx-auto mb-4 w-11 h-11 rounded-[12px] border border-periwinkle-border bg-surface-background flex items-center justify-center text-periwinkle"
  >
    <span class="material-icons text-[22px]" aria-hidden="true">{{
      icon
    }}</span>
  </div>
  <div class="inter-500 text-[15px] text-inverted-neutral">
    {{ title }}
  </div>
  @if (message) {
    <div class="inter-300 text-[14px] text-support-text mt-2 max-w-[520px] mx-auto">
      {{ message }}
    </div>
  }
  <ng-content></ng-content>
</div>
